export default __webpack_public_path__ + "static/media/area-78.850eb5ae.jpg";